
const notFoundPicture = require("@/assets/images/404-not-found.svg");

import { Vue, Component } from "vue-property-decorator";

@Component
export default class NotFound extends Vue {

  private notFoundPicture = notFoundPicture;

  private goHome() {
    this.$router.push("/");
  }

}
